import axios from "axios";
import { hostname } from "src/HostName";

const userHistoryInstance = axios.create({
  baseURL: hostname,
  headers: {
    "Content-Type": "application/json",
  },
});
export const getUserHistoryApi = () =>
  userHistoryInstance.get(`get/userhistory`);
